import { render, staticRenderFns } from "./EvaluacionStatusChip.vue?vue&type=template&id=13595344"
import script from "./EvaluacionStatusChip.vue?vue&type=script&lang=js"
export * from "./EvaluacionStatusChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports